import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { httpGet } from '../../http';
import { Link } from 'react-router-dom';
import './Egresos.css';
import { Spinner } from 'react-bootstrap';
import { formatNumber, formatDateMin } from '../../misc/index';


const Egresos = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    useEffect(() => {

        console.log(JSON.parse(sessionStorage.getItem('estado')));

        let newEstado = JSON.parse(sessionStorage.getItem('estado'));
        newEstado.proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        console.log(newEstado);
        
        setEstado(newEstado);
        getEgresos(newEstado.proveedor.nit);

    }, []);

    const getEgresos = (tercero) => {
        setEgresos({
            ...egresos,
            loading: true
        });
        httpGet('/api/v1/egresos/nit/' + tercero + "?pagina=0&cant=100").then(
            resp => {
                setEgresos({
                    ...egresos,
                    data: resp.data,
                    loading: false
                });
            }
        ).catch(
            error => {
                console.log(error);
                setEgresos({
                    ...egresos,
                    loading: false
                });
            }
        );
    }

    const [egresos, setEgresos ] = useState(
        {
            data: [],
            loading: true,
            error: {}
        }
    );

    const generarEgresoDetallePdf = async (e, egreso2) => {
        e.preventDefault();

        console.log(egreso2);
        
        const encabezado = await httpGet('/ProveedoresWSNEW/api/Egresos/encabezado?co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);
        const detalles = await httpGet('/ProveedoresWSNEW/api/Egresos/detalle?co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);

        if((encabezado !== null) && (encabezado !== undefined)){
            let egreso = {
                proveedor: estado.proveedor,
                encabezado: encabezado.data,
                detalles: detalles.data
            }

            console.log(egreso);

            props.history.push({ pathname: '/portal/egreso-pdf', state: { egreso: egreso } });
        }
        
    }

    return(
        <div className='page-container'>
            <Title>Comprobantes de egreso</Title>
            {egresos.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
            :
                <div className='page-body'>
                    <table className='info-table'>
                        <thead>
                            <tr>
                                <th>DOCUMENTO</th>
                                <th>FECHA DEL DOCUMENTO</th>
                                <th>VALOR DEL DOCUMENTO</th>
                                <th>VER</th>
                                {/*<th>DESCARGAR</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                egresos.data.map(
                                    egreso => {
                                        return(
                                            <tr key={egreso.id}>
                                                <td>{ egreso.tipoDoc + '-' + egreso.numeroDoc }</td>
                                                <td>{ formatDateMin(new Date(egreso.fechaDoc)) }</td>
                                                <td>${ formatNumber(egreso.valor) }</td>
                                                <td><div className='view-icon-container'><Link to={{ pathname: "/portal/egreso-detalle", state: { egreso: egreso } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link></div></td>
                                                {/*<td><div className='pdf-icon-container' ><Link style={{ color: 'red' }} onClick={(e) => { generarEgresoDetallePdf(e, egreso) }}><FontAwesomeIcon className='view-icon' icon={faFilePdf} /></Link></div></td>*/}
                                            </tr>
                                        );
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default Egresos
